/**
 *
 * @param {StarzPlayerConfiguration} configuration
 * @param seriesFeed
 * @constructor
 */
import LanguageManager from '../language_manager/language_manager';
var config = require('../../config');
var HttpUtils = require('../../util/http_utils');
var ObjectUtils = require('../../util/object_utils');
var feed = require('../feed/feed');
var DomUtils = require('../../util/dom_utils');

const emptyImage = `${config.httpsCdnUrl}/prd-peg-data/default/images/errorPage/no-image-seasons.jpg`;

/**
 *
 * @param {StarzPlayerConfiguration} configuration
 * @param seriesFeed
 * @constructor
 */
function EpisodeSelector(starzplayerInstance, configuration, seriesFeed, eventEmitter, adapter) {
    ObjectUtils.assertEmpty(seriesFeed, 'seriesFeed');
    ObjectUtils.assertEmpty(starzplayerInstance, 'starzplayerInstance');

    this.active = false;
    this.starzplayer = starzplayerInstance;
    this.seriesFeed = seriesFeed;
    this.adapter = adapter;
    this.configuration = configuration;
    this.feed = feed;
    this.cachedSeasonsDom = {};
    this.listeners = {
        beforeEpisodeChange: []
    };

    this.currentSeason = configuration.content.series.season || 0;
    this.nOfSeasons = 0;
    this.nOfEpisodes = 0;
    this.episodeJumpLock = true;

    // Scroller stuff
    this.scrollingAmount = 120;
    this.scrollable = false;

    this.eventEmitter = eventEmitter;

    this.getSeriesInformation();

    this.nextEpisodeObject = {
        episode: parseInt(this.configuration.content.series.nextEpisode),
        season: parseInt(this.configuration.content.series.nextSeason),
        waitTime: 15,
        next_episode_in: LanguageManager.get('next_episode_in'),
        seconds: LanguageManager.get('seconds'),
        dismiss: LanguageManager.get('dismiss')
    };
}

EpisodeSelector.prototype.addIcon = function() {

    var captionsButton = document.getElementsByClassName('bitdash-captions')[0];
    var button = document.createElement('button');
    var _this = this;
    button.innerHTML = 'SEL';
    button.type = 'button';
    button.className = 'bitdash-seasons';
    button.dataset.state = 'seasons';
    button.textContent = 'Seasons';
    button.onclick = function() {
        _this.active ? _this.show() : _this.hide();
    };

    let toolTip = document.createElement('div');
    toolTip.classList.add('bitdash-btns');
    toolTip.classList.add('bitdash-btns-video-selector');
    toolTip.setAttribute('data-tooltip', LanguageManager.get('tooltip_episodes'));
    toolTip.appendChild(button);

    const isAdded = document.querySelector('.bitdash-seasons');

    if (!isAdded) {    
        captionsButton.parentNode.insertBefore(toolTip, captionsButton);
    }

};

EpisodeSelector.prototype.init = function() {
    var _this = this;
    this.active = true;
    _this.seasonHtml = '';
    var module = '';

    this.getEpisodes(function(success, data) {
        if (success && data) {
            _this.nOfEpisodes = data.titles.length;
            var Handlebars = require('handlebars-template-loader/runtime');

            // Require partial
            var partial = require('./_episodes.hbs');

            // Register partial
            Handlebars.registerPartial('_episodes', partial);

            var html = require('./episode_selector.hbs')(data);
            module = DomUtils.createElementFromString(html);
            _this.getSeasons(function(success, data) {
                if (success && data) {
                    _this.nOfSeasons = data.titles.length;
                    data.season = LanguageManager.get('season');
                    _this.seasonHtml = require('./series_list.hbs')(data);
                } else {
                    _this.seasonHtml = 'Something went wrong while fetching the information for the other episodes';
                }
                document.getElementById(config.playerElementId).getElementsByClassName('bitdash-ctrl-w')[0].appendChild(module);
                document.getElementById('SERIES_LIST').insertAdjacentHTML('afterbegin', _this.seasonHtml);
                _this.attachScrollArrowsEvents();
                _this.attachEpisodeEvents();
                _this.attachSeasonsEvents();
                _this.initNextEpisodeComponent();
            });
        } else {
            this.module.innerHTML = 'Something went wrong while fetching the information for the other episodes';
            document.getElementById(config.playerElementId).getElementsByTagName('figure')[0].appendChild(module);
        }
    });
};

EpisodeSelector.prototype.show = function() {
    var seasonElements = document.querySelectorAll('#SERIES_LIST .seasonSel-item');
    var episodeElements = document.querySelectorAll('#CHAPTERS_LIST .chapter');

    this.handleArrowsDependinOnScrollPos();
    this.active = false;
    this.module = document.querySelector('#starzplayer .bitdash-settings--seasons');
    this.module.setAttribute('data-is-visible', '1');

    if (this.module) {
        this.module.classList.add('is-shown');
        document.querySelector('.bitdash-seasons').classList.add('is-active');
        this.checkScrollableArea();
    }
    this.module = true;
    if (this.configuration.content.series !== undefined) {
        if (seasonElements.length > 1) {
            DomUtils.removeAllClass(seasonElements, 'is-active');
            seasonElements[this.configuration.content.series.season - 1]
                .getElementsByTagName('a')[0]
                .classList
                .add('is-active');
        } else if (seasonElements.length === 1) {
            seasonElements[0]
                .getElementsByTagName('a')[0]
                .classList
                .add('is-active');
        }

        if (episodeElements.length > 0) {
            DomUtils.removeAllClass(episodeElements, 'chapter--current');
            this.highlightChapters(episodeElements, this.configuration.content.series.episode - 1);
        }
    }
    this.eventEmitter.emit('menu-shown', 'episode-selector');
};

EpisodeSelector.prototype.isLastEnd = function() {
    return !this.configuration.content.series.nextEpisode;
};

EpisodeSelector.prototype.initNextEpisodeComponent = function() {
    const nextEpisodeNumber = parseInt(this.configuration.content.series.nextEpisode);
    const nextSeasonNumber = parseInt(this.configuration.content.series.nextSeason);

    const nextEpisodeElement = document.querySelector(`.chapter[data-episode-number='${nextEpisodeNumber}'].chapter[data-season-number='${nextSeasonNumber}']`) || {};

    if (nextEpisodeElement !== {}) {
        this.nextEpisodeObject = {
            episode: nextEpisodeNumber,
            season: nextSeasonNumber,
            title: (nextEpisodeElement.querySelector) ? nextEpisodeElement.querySelector('.chapter-title').innerText : '',
            description: (nextEpisodeElement.querySelector) ? nextEpisodeElement.querySelector('.chapter-text').innerText : '',
            thumbUrl: (nextEpisodeElement.querySelector) ? nextEpisodeElement.querySelector('img').src : '',
            waitTime: 15,
            next_episode_in: LanguageManager.get('next_episode_in'),
            seconds: LanguageManager.get('seconds'),
            dismiss: LanguageManager.get('dismiss')
        };
        this.renderNextChapter();
    }
};

EpisodeSelector.prototype.renderNextChapter = function() {
    var _this = this;
    var html = require('./next_episode.hbs')(Object.assign(_this.nextEpisodeObject, {emptyImage: emptyImage}));
    var module = DomUtils.createElementFromString(html);
    document.getElementById(config.playerElementId).getElementsByClassName('bitdash-ctrl-w')[0].appendChild(module);

    document.querySelector('#DISMISS_NEXT_EPISODE').addEventListener('click', function(e) {
        _this.episodeJumpLock = false;
        _this.hideNextEpisodePreview();
        _this.show();

        e.preventDefault();
        e.stopPropagation();
    }, false);

    document.querySelector('#PLAY_NOW_NEXT_EPISODE').addEventListener('click', function(e) {

        _this.episodeJumpLock = true;
        _this.nextPlayChain();

        e.preventDefault();
        e.stopPropagation();
    }, false);
};

EpisodeSelector.prototype.showNextEpisodePreview = function() {
    if (this.nextEpisodeTimer) return; // Already active
    var nextEpisodeElement = document.querySelectorAll('.bitdash-settings--next');
    var isLastEndEpisode = this.isLastEnd();
    if (nextEpisodeElement.length > 0 && !isLastEndEpisode) {
        nextEpisodeElement = nextEpisodeElement[0];
        nextEpisodeElement.classList.add('is-shown');

        this.nextEpisodeTimer = setInterval(() => {
            const elem = nextEpisodeElement.querySelector('.count-counter');
            if (elem.innerHTML > 0) {
                elem.innerHTML = elem.innerHTML - 1;
            } else {
                clearInterval(this.nextEpisodeTimer);
                this.nextPlayChain();
            }
        }, 1000);
    } else {
        this.show();
    }
};

EpisodeSelector.prototype.hideNextEpisodePreview = function() {
    let nextEpisodeComponent = document.querySelector('.bitdash-settings--next');
    if (nextEpisodeComponent) {
        nextEpisodeComponent.classList.remove('is-shown');
    }
};

EpisodeSelector.prototype.highlightChapters = function(chapterElementsList, lastWatchedIndex) {
    const currentEpisode = lastWatchedIndex + 1;
    for (var i = 0; i <= lastWatchedIndex || i === 0; i++) {
        const chapter = chapterElementsList[i];
        const episodeNumber = parseInt(chapter.dataset.episodeNumber);
        if (currentEpisode > episodeNumber) {
            chapter.classList.add('chapter--watched');
        } else if (episodeNumber === currentEpisode) {
            chapter.classList.add('chapter--current');
            var topPos = document.querySelector('.chapter--current').offsetTop - 120;
            document.getElementById('CHAPTER_SCROLLABLE').scrollTop = topPos;
            if ((topPos) < 10) {
                CHAPTER_UP.classList.add('hide-arrow');
            } else {
                CHAPTER_UP.classList.remove('hide-arrow');
            }
            break;
        }
    }
};

EpisodeSelector.prototype.hide = function() {
    this.active = true;

    this.module = document.querySelector('#starzplayer .bitdash-settings--seasons');
    if (this.module) {
        this.module.classList.remove('is-shown');
        document.querySelector('.bitdash-seasons').classList.remove('is-active');
    }
    this.module = false;
    this.eventEmitter.emit('menu-hidden', 'episode-selector');
};

EpisodeSelector.prototype.getSeriesInformation = function(callback) {
    callback = callback || function() {
    };
    var _this = this;
    if (_this.seriesData) {
        callback(true, _this.seriesData);
    } else {
        HttpUtils.get({uri: _this.seriesFeed}, function(success, body) {
            if (success && body) {
                var data = JSON.parse(body);
                callback(true, data);
            } else {
                callback(false, body);
            }
        });
    }
};

EpisodeSelector.prototype.getEpisodes = function(callback) {
    callback = callback || function() {
    };
    var _this = this;
    HttpUtils.get({uri: feed.getEpisodesFeedUrl(_this.seriesFeed, _this.configuration.content.series.season)}, function(success, body) {
        if (success && body) {
            var data = JSON.parse(body.replace(new RegExp(config.httpCdnUrl, 'g'), config.httpsCdnUrl));
            callback(true, data);
        } else {
            callback(false, body);
        }
    });
};

EpisodeSelector.prototype.getNewSeasonEpisode = function(callback) {
    callback = callback || function() {
    };
    var _this = this;
    HttpUtils.get({
        uri: feed.getFirstEpisodeFeedUrl(_this.seriesFeed,
            (parseInt(_this.configuration.content.series.season) + 1),
            _this.configuration.content.language)
    }, function(success, body) {
        if (success && body) {
            var data = JSON.parse(body);
            data = data['titles'][0] || data;
            callback(true, data);
        } else {
            callback(false, body);
        }
    });
};

EpisodeSelector.prototype.getSeasons = function(callback) {
    var _this = this;
    HttpUtils.get({uri: feed.getSeasonFeed(_this.seriesFeed)}, function(success, body) {
        if (success && body) {
            var data = JSON.parse(body);
            callback && callback(true, data);
        } else {
            callback && callback(false, body);
        }
    });
};

EpisodeSelector.prototype.attachEpisodeEvents = function() {
    var links = document.querySelectorAll('#starzplayer .chapter-list .chapter');
    var _this = this;
    for (var $i = 0; $i < links.length; $i++) {
        links[$i].addEventListener('click', function(e) {
            _this.goTo(this.dataset.seasonNumber, this.dataset.episodeNumber);
            e.stopPropagation();
            e.preventDefault();
        }, false);
    }
};

EpisodeSelector.prototype.stopScrollBubbling = function(e) {
    e = e || window.event;
    if (e.preventDefault) {
        e.preventDefault();
    }
    e.returnValue = false;
};

EpisodeSelector.prototype.attachScrollArrowsEvents = function() {
    var _this = this;
    var arrowUpElement = document.querySelector('#CHAPTER_UP');
    var arrowDownElement = document.querySelector('#CHAPTER_DOWN');

    document.getElementById('CHAPTER_SCROLLABLE').onmousewheel = function(e) {
        document.getElementById('CHAPTER_SCROLLABLE').scrollTop -= e.wheelDeltaY;
        _this.stopScrollBubbling(e);
        _this.handleArrowsDependinOnScrollPos();
    };

    arrowUpElement.addEventListener('click', function(e) {
        _this.scrollToTop();
        e.stopPropagation();
        e.preventDefault();
        var scrollPosition = document.getElementById('CHAPTER_SCROLLABLE').scrollTop;
        CHAPTER_DOWN.classList.remove('hide-arrow');
        if ((scrollPosition) < 10) {
            CHAPTER_UP.classList.add('hide-arrow');
        } else {
            CHAPTER_UP.classList.remove('hide-arrow');
        }
    }, false);

    arrowDownElement.addEventListener('click', function(e) {
        _this.scrollToBottom();
        e.stopPropagation();
        e.preventDefault();
        var scrollPosition = document.getElementById('CHAPTER_SCROLLABLE').scrollTop;
        var chapterHeight = document.getElementById('CHAPTER_SCROLLABLE').scrollHeight;
        var offsetHeight = document.getElementById('CHAPTER_SCROLLABLE').offsetHeight;
        CHAPTER_UP.classList.remove('hide-arrow');
        if ((scrollPosition + offsetHeight) >= chapterHeight) {
            CHAPTER_DOWN.classList.add('hide-arrow');
        } else {
            CHAPTER_DOWN.classList.remove('hide-arrow');
        }
        2;
    }, false);

};

EpisodeSelector.prototype.handleArrowsDependinOnScrollPos = function() {
    var scrollPosition = document.getElementById('CHAPTER_SCROLLABLE').scrollTop;
    var chapterHeight = document.getElementById('CHAPTER_SCROLLABLE').scrollHeight;
    var offsetHeight = document.getElementById('CHAPTER_SCROLLABLE').offsetHeight;
    if ((scrollPosition) < 10) {
        CHAPTER_UP.classList.add('hide-arrow');
    } else {
        CHAPTER_UP.classList.remove('hide-arrow');
    }
    if ((scrollPosition + offsetHeight) === chapterHeight) {
        CHAPTER_DOWN.classList.add('hide-arrow');
    } else {
        CHAPTER_DOWN.classList.remove('hide-arrow');
    }
};

EpisodeSelector.prototype.attachSeasonsEvents = function() {
    var links = document.querySelectorAll('#starzplayer ul.seasonSel .seasonSel-item a');
    var scrollPosition = document.getElementById('CHAPTER_SCROLLABLE').scrollTop;
    var chapterHeight = document.getElementById('CHAPTER_SCROLLABLE').scrollHeight;
    var offsetHeight = document.getElementById('CHAPTER_SCROLLABLE').offsetHeight;
    var _this = this;
    for (var $i = 0; $i < links.length; $i++) {
        var clickedElement = '';
        links[$i].addEventListener('click', function(e) {
            clickedElement = this;
            if (!clickedElement.classList.contains('is-active')) {
                _this.switchSeason(this.dataset.seasonNumber);
                DomUtils.removeAllClass(links, 'is-active');
                clickedElement.classList.add('is-active');
                if ((scrollPosition) < 10) {
                    CHAPTER_UP.classList.add('hide-arrow');
                } else {
                    CHAPTER_UP.classList.remove('hide-arrow');
                }
                if ((scrollPosition + offsetHeight) === chapterHeight) {
                    CHAPTER_DOWN.classList.add('hide-arrow');
                } else {
                    CHAPTER_DOWN.classList.remove('hide-arrow');
                }
            }

            e.stopPropagation();
            e.preventDefault();
        }, false);
    }
};

EpisodeSelector.prototype.goTo = function(seasonNo, episodeNo) {
    var _this = this;
    this.starzplayer.reinitialize({
        feed: _this.configuration.content.feed, // required
        mpxToken: _this.configuration.user.mpxToken, // required
        sessionToken: _this.configuration.user.sessionToken, // required
        videoType: _this.configuration.content.videoType,

        // Recommendation engine
        recEngineModuleId: _this.configuration.recEngine.moduleId,
        parentalControl: _this.configuration.recEngine.parentalControl,

        language: _this.configuration.content.language,

        // Series, optional
        episode: (episodeNo !== undefined) ? episodeNo : 1,
        season: (seasonNo !== undefined) ? seasonNo : 1,

        // EventHandlers for this content. This gives the client to use some of the eventHandlers. They will need to be defined as the client does not have access to all eventHandlers!
        eventHandlers: _this.configuration.eventHandlers
    });
};

EpisodeSelector.prototype.switchSeason = function(seasonNo) {
    var _this = this;
    var episodesHTML = '';
    _this.configuration.content.series.season = seasonNo;
    if (_this.cachedSeasonsDom[seasonNo]) {
        episodesHTML = _this.cachedSeasonsDom[seasonNo];
        document.getElementById('CHAPTERS_LIST').innerHTML = '';
        document.getElementById('CHAPTERS_LIST').insertAdjacentHTML('afterbegin', episodesHTML);
        _this.attachEpisodeEvents();
        _this.checkScrollableArea();
        if (seasonNo == _this.currentSeason) {
            _this.setCurrent(seasonNo, _this.configuration.content.series.episode);
        } else if (seasonNo < _this.currentSeason) {
            _this.setCurrent(seasonNo, -1);
        }
    } else {
        _this.episodesLoadingIndication('.chapter-list');
        _this.getEpisodes(function(success, data) {
            if (success && data) {
                if(data.error_code) {
                    //Empty Season
                    if(data.error_code === '51003'){
                        episodesHTML = "<p class='empty-season'>" + LanguageManager.get('empty_episodes') + "</p>";
                        CHAPTER_DOWN.classList.add('hide-arrow');
                        CHAPTER_UP.classList.add('hide-arrow');
                    }
                } else {
                    data.emptyImage = emptyImage;
                    episodesHTML = require('./_episodes.hbs')(data);
                    _this.cachedSeasonsDom[seasonNo] = episodesHTML;
                    CHAPTER_DOWN.classList.remove('hide-arrow');
                }
            } else {
                episodesHTML = 'Something went wrong while fetching the information for the other episodes';
            }
            document.getElementById('CHAPTERS_LIST').innerHTML = '';
            document.getElementById('CHAPTERS_LIST').insertAdjacentHTML('afterbegin', episodesHTML);
            _this.attachEpisodeEvents();
            _this.checkScrollableArea();
            if (seasonNo == _this.currentSeason) {
                _this.setCurrent(seasonNo, _this.configuration.content.series.episode);
            } else if (seasonNo < _this.currentSeason) {
                _this.setCurrent(seasonNo, -1);
            }
        });
    }
};

EpisodeSelector.prototype.setCurrent = function(seasonNo, currentEpisode) {
    let episodeElements = document.querySelectorAll('#CHAPTERS_LIST .chapter');

    if (episodeElements.length > 0 && currentEpisode > -1) {
        this.highlightChapters(episodeElements, currentEpisode - 1);
    } else if (episodeElements.length > 0 && currentEpisode == -1) {
        this.highlightChapters(episodeElements, episodeElements.length);
    }
};

EpisodeSelector.prototype.addEventListener = function(eventName, callback) {
    var _this = this;
    _this.listeners[eventName].push(callback);
};

EpisodeSelector.prototype.emit = function(eventName) {
    var _this = this;
    _this.listeners[eventName].forEach(function(listener) {
        listener();
    });
};

EpisodeSelector.prototype.scrollToTop = function() {
    if (this.scrollable) {
        document.getElementsByClassName('chapter-module')[0].scrollTop -= this.scrollingAmount;
    }
    return this.scrollingAmount;
};

EpisodeSelector.prototype.scrollToBottom = function(strollTo) {
    if (this.scrollable) {
        document.getElementsByClassName('chapter-module')[0].scrollTop += this.scrollingAmount;
    }
    return this.scrollingAmount;
};

EpisodeSelector.prototype.checkScrollableArea = function() {
    const scrollableElement = document.querySelector('.chapter-module');
    const listOfEpisodesElement = document.querySelector('#CHAPTERS_LIST');

    this.scrollable = listOfEpisodesElement.offsetHeight > scrollableElement.offsetHeight;
    this.scrollingAmount = parseInt((scrollableElement.offsetHeight - 7) / 3);
};

EpisodeSelector.prototype.nextPlayChain = function() {
    this.episodeJumpLock && this.goTo(this.configuration.content.series.nextSeason, this.configuration.content.series.nextEpisode);
};

EpisodeSelector.prototype.episodesLoadingIndication = function(selectedAreaClass) {
    let element = document.querySelector(selectedAreaClass);
    element.innerHTML = '<div class="loader-line"><div class="loader-bar"></div></div>';
    CHAPTER_UP.classList.add('hide-arrow');
    CHAPTER_DOWN.classList.add('hide-arrow');
};

EpisodeSelector.clean = function() {
    DomUtils.destroyElementByType('class', 'bitdash-settings--next');
    DomUtils.destroyElementByType('class', 'bitdash-seasons');
    DomUtils.destroyElementByType('class', 'bitdash-settings--seasons');
    DomUtils.destroyElementByType('class', 'player-modal--end');
};

module.exports = EpisodeSelector;



// WEBPACK FOOTER //
// ./src/modules/episode_selector/episode_selector.js